import t from"styled-components";import e from"react";import o from"prop-types";import{calculateRem as i}from"@vds-core/utilities";import{LayoutTokens as r}from"@vds-tokens/layout";const s={width:o.string,Checkbox:o.func},n=r.space["6X"].value,p=t.div.withConfig({displayName:"CheckboxWrapper",componentId:"VDS__sc-14uessv-0"})`
  box-sizing: border-box;
  display: inline-flex;
  flex: 0 0 1;
  padding: 0 0 ${i(n)} 0;
  width: 100%;

  > * {
    margin-bottom: 0;
  }

  &:last-child {
    padding-bottom: 0;
  }
`,a=t=>{const{Checkbox:o}=t;return e.createElement(p,{"data-testid":"test-group-item",onClick:function(t){"click"===t.type&&0!==t.detail&&t.currentTarget.blur()}},e.createElement(o,Object.assign({},t)))};a.propTypes=s,a.defaultProps={width:"100%"};export{a as default};
